
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const ServicesPage = () => {
  const services = [
    {
      icon: 'ri-hammer-line',
      title: '噴砂噴漆服務',
      description: '專業金屬表面處理，提供完整的噴砂除鏽與高品質噴漆服務，確保表面光滑耐用。',
      features: ['金屬表面除鏽', '防鏽底漆處理', '高品質面漆', '表面平整處理'],
      image: 'https://static.readdy.ai/image/e7430320e3bc3f9244a461515e2266b3/fe67df12de662aebbd1e997548fb5355.jpeg'
    },
    {
      icon: 'ri-shield-line',
      title: '防鏽處理',
      description: '採用先進防鏽技術，延長設備使用壽命，有效防止金屬腐蝕與氧化問題。',
      features: ['腐蝕評估', '防鏽塗層', '長效保護', '定期維護'],
      image: 'https://static.readdy.ai/image/e7430320e3bc3f9244a461515e2266b3/7b46f57b5ef040718ce753cd56017135.jpeg'
    },
    {
      icon: 'ri-building-2-line',
      title: '工程承攬',
      description: '承接各類工業與公共工程專案，從規劃到完工提供一站式專業服務。',
      features: ['工程規劃', '施工管理', '品質控制', '完工驗收'],
      image: 'https://public.readdy.ai/ai/img_res/250ccd78ce6604de6e87c6f43f86b55e.jpg'
    },
    {
      icon: 'ri-truck-line',
      title: '工程器具轉運運輸',
      description: '提供專業的工程設備與器具運輸服務，確保設備安全運送到指定地點。',
      features: ['設備包裝', '安全運輸', '現場卸貨', '運輸保險'],
      image: 'https://static.readdy.ai/image/e7430320e3bc3f9244a461515e2266b3/652ffc86f95784c011e7558d8c5e9d2b.jpeg'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                專業<strong>噴砂噴漆</strong>服務項目
              </h1>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                我們提供全方位的<strong>工程承攬</strong>服務，從金屬表面處理到大型工程專案，
                以專業技術與豐富經驗，為您的建築與設備提供最佳保護。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
              {services.map((service, index) => (
                <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300">
                  <div className="grid grid-cols-1 lg:grid-cols-2">
                    <div className="relative h-64 lg:h-auto overflow-hidden">
                      <img 
                        src={service.image}
                        alt={service.title}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    <div className="p-6 flex flex-col justify-center">
                      <div className="flex items-center mb-4">
                        <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4">
                          <i className={`${service.icon} text-teal-600 text-xl`}></i>
                        </div>
                        <h2 className="text-xl font-semibold text-gray-900">{service.title}</h2>
                      </div>
                      <p className="text-gray-600 mb-4 leading-relaxed">{service.description}</p>
                      <ul className="space-y-2">
                        {service.features.map((feature, featureIndex) => (
                          <li key={featureIndex} className="flex items-center text-gray-600">
                            <i className="ri-check-line text-teal-600 mr-2"></i>
                            {feature}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-white rounded-xl shadow-lg p-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">服務流程</h2>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                <div className="text-center">
                  <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-teal-600 font-bold text-xl">1</span>
                  </div>
                  <h3 className="font-semibold text-gray-900 mb-2">需求評估</h3>
                  <p className="text-gray-600 text-sm">詳細了解客戶需求與現場狀況</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-teal-600 font-bold text-xl">2</span>
                  </div>
                  <h3 className="font-semibold text-gray-900 mb-2">方案規劃</h3>
                  <p className="text-gray-600 text-sm">制定最適合的施工方案與報價</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-teal-600 font-bold text-xl">3</span>
                  </div>
                  <h3 className="font-semibold text-gray-900 mb-2">專業施工</h3>
                  <p className="text-gray-600 text-sm">按照標準流程進行專業施工</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-teal-600 font-bold text-xl">4</span>
                  </div>
                  <h3 className="font-semibold text-gray-900 mb-2">品質驗收</h3>
                  <p className="text-gray-600 text-sm">嚴格品質檢驗確保客戶滿意</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ServicesPage;
